module.exports = __webpack_public_path__ + "img/ys-3.7f0dc686.svg";